module.exports = __webpack_public_path__ + "static/dharini-cbc18c141443e5ae3dacb688e649df85.jpg";